"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreePopup = void 0;
const react_1 = __importStar(require("react"));
const react_vtree_1 = require("react-vtree");
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const tree_styles_1 = require("./tree-styles");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tree_context_1 = require("./tree-context");
const tree_item_1 = require("./tree-item");
const react_window_infinite_loader_1 = __importDefault(require("react-window-infinite-loader"));
const lodash_1 = require("lodash");
function TreePopup({ setPopupOpen, setTextValue, anchorElRef, }) {
    const classes = tree_styles_1.useStyles();
    const { source, value, onChange, disabled } = react_1.useContext(tree_context_1.TreeContext);
    react_1.useEffect(() => {
        var _a;
        const keys = new Set((_a = (value !== null && value !== void 0 ? value : [])) === null || _a === void 0 ? void 0 : _a.map((v) => v.id));
        source.setSelectedKeys(keys);
    }, [value]);
    const handleSelect = event_callback_hook_1.useEventCallback((key) => {
        var _a;
        const selected = source.selectedKeys.has(key);
        if (selected) {
            const newValue = value === null || value === void 0 ? void 0 : value.filter((v) => v.id !== key);
            onChange(newValue);
        }
        else {
            const item = (_a = source.getItem(key)) === null || _a === void 0 ? void 0 : _a.value;
            onChange([
                ...(value !== null && value !== void 0 ? value : []),
                { id: item === null || item === void 0 ? void 0 : item.id, label: item === null || item === void 0 ? void 0 : item.label },
            ]);
        }
    });
    const handleClickAway = event_callback_hook_1.useEventCallback(() => {
        setTextValue('');
        setPopupOpen(false);
    });
    const isItemLoaded = react_1.useCallback((index) => {
        return index < source.items.length;
    }, [source]);
    const loadMoreItems = source.loading ? async () => lodash_1.noop() : source.loadMore;
    return (react_1.default.createElement(Popper_1.default, { className: classes.popper, role: "presentation", anchorEl: anchorElRef.current, placement: "bottom-start", open: true },
        react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClickAway },
            react_1.default.createElement(Paper_1.default, { className: classes.paper, square: true, elevation: 8 }, source.items.length > 0 && (react_1.default.createElement(react_window_infinite_loader_1.default, { isItemLoaded: isItemLoaded, itemCount: source.count, loadMoreItems: loadMoreItems, threshold: 1 }, ({ onItemsRendered, ref }) => (react_1.default.createElement(react_vtree_1.FixedSizeTree, { ref: ref, treeWalker: () => source.treeWalker(handleSelect), itemSize: 26, height: 300, width: "100%", async: true, onItemsRendered: onItemsRendered, itemData: {
                    disabled,
                } }, tree_item_1.TreeItem))))))));
}
exports.TreePopup = TreePopup;
//# sourceMappingURL=tree-popup.js.map